import classNames from 'classnames';
import type React from 'react';
import { memo } from 'react';

import styles from 'src/widgets/policy/components/links.module.scss';

import { useAnalytics } from '@features/Analytics';
import { FormattedMessage } from '@features/intl';

export const RefundLink = memo(
  ({
    place,
    className,
    children,
  }: {
    place: 'paywall' | 'checkout' | 'burger_menu' | 'email_modal' | 'upsale';
    className?: string;
    children?: React.ReactNode;
  }) => {
    const { trackGoogleEvent } = useAnalytics();
    return (
      <a
        className={classNames(styles.link, className)}
        href="https://legal.mentalgrowth.app/youth/refund-policy.pdf"
        target="_blank"
        rel="noreferrer"
        onClick={() =>
          trackGoogleEvent({
            eventName: 'link_open',
            options: {
              place: place,
              link_name: 'refund policy',
            },
          })
        }
      >
        {children || (
          <FormattedMessage
            id="Onboarding.Paywall.Main.Contact.RefundPolicy.A"
            defaultMessage="Refund policy"
          />
        )}
      </a>
    );
  },
);

RefundLink.displayName = 'RefundLink';
